import { ReactComponent as ImgLogo } from './logo.svg';

const Logo = () => (
  <div className='w-100 d-flex justify-content-center'>
    <ImgLogo />
  </div>
)

export default Logo;